export const CloseIcon = ({ onClick, className }: { onClick: () => void; className?: string }) => {
  return (
    <img className={`hover:cursor-pointer ${className}`} src="/assets/close.svg" alt="'close icon" onClick={onClick} />
  );
};
